import React from 'react';
import ResultPageModalButtons from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModalButtons';

function AncillariAutoModalButtons({
  insuranceRequest,
  processingQuote,
  type,
  riskQuotations,
  removeItemFromCart,
}) {
  const title = type.id === 'res_civile' && insuranceRequest.product.id === 11
    ? 'Incendio Fabbricato'
    : type.id === 'res_civile' && insuranceRequest.product.id === 13
      ? 'Furto e Incendio'
      : type.name;

  return (
    <ResultPageModalButtons
      insuranceRequest={insuranceRequest}
      processingQuote={processingQuote}
      type={type}
      riskQuotations={riskQuotations}
      removeItemFromCart={removeItemFromCart}
      title={title}
      selectFirstLabel="Furto e Incendio"
      wrapMainInCol
      riskRowCompanyGate
    />
  );
}

export default AncillariAutoModalButtons;
